<template>
    <div>
        <div class="common-header">
            <el-button type="primary" @click="showAdd = true">新增支付渠道</el-button>
            <div style="padding-left: 10px;font-size: 14px">
                <p v-for="item of channelClubsQuery"
                   :key="item.type">{{item.type |
                    topUpTypeName}}：{{item.configuredCount}}/{{item.notConfiguredCount}}</p>
            </div>

            <div class="common-header-right">
                <div class="common-header-block">
                    <el-input
                            class="common-el-input"
                            placeholder="请输入渠道ID查询"
                            v-model="searchVal">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="getList()">搜索</el-button>
                </div>
            </div>
        </div>

        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="channelList.beanList"
                    row-key="id"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="渠道ID" align="center" prop="id"/>
                <el-table-column label="渠道名称" width="150" align="center" prop="name"/>
                <el-table-column label="渠道类型" align="center" prop="paymentCode"/>
                <el-table-column label="代充仓余额" min-width="150" align="center">
                    <template slot-scope="scope">{{scope.row.cmsAccountChip}} 金豆</template>
                </el-table-column>
                <el-table-column label="联系方式" min-width="150" align="center" prop="contactAccount"/>
                <el-table-column label="是否开启战绩返佣" width="180" align="center">
                    <template slot-scope="scope">
                        <el-switch
                                :value="scope.row.openRebate"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="开启"
                                inactive-text="关闭"
                                @change="updateRebate(scope.row.id,$event)"/>
                    </template>
                </el-table-column>
                <el-table-column label="俱乐部个数" min-width="120" align="center" prop="clubCount"/>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="editFunc(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="deleteFunc(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="channelList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>

        <comp-set ref="edit" :info="selectChannel" @my-close="getList(currentPage)" @my-update="updateSelectChannel"/>

        <div v-show="showAdd" class="common-popup-bg">
            <div class="common-popup">
                <h3>新增充值渠道</h3>
                <el-form ref="addForm" class="form" :model="form" :rules="rules" size="medium" label-width="135px">
                    <el-form-item label="支付渠道名称：" prop="name">
                        <el-input placeholder="请输入" v-model="form.name"/>
                    </el-form-item>
                    <el-form-item label="绑定CMS账号：" prop="cmsAccount">
                        <el-input placeholder="请输入" v-model="form.cmsAccount"/>
                    </el-form-item>
                    <el-form-item label="联系方式：" prop="contactAccount">
                        <el-input placeholder="请输入" v-model="form.contactAccount"/>
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('addForm')">取消</el-button>
                    <el-button size="small" @click="submitForm('addForm')" type="primary">确定</el-button>
                </footer>
            </div>
        </div>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>删除渠道</h3>
                <el-form ref="removeForm" class="form" :model="removeForm" :rules="removeRules" size="medium"
                         label-width="90px">
                    <el-form-item label="账号：" prop="account">
                        <el-input placeholder="请输入" v-model="removeForm.account"/>
                    </el-form-item>
                    <el-form-item label="密码：" prop="password">
                        <el-input placeholder="请输入" type="password" v-model="removeForm.password"/>
                    </el-form-item>
                    <el-form-item label="验证码：" prop="smsCode">
                        <el-input placeholder="请输入" v-model="removeForm.smsCode">
                            <btn-countdown
                                    slot="append"
                                    @my-click="sendCodeToMyPhone({err:$event.err,type:13})"
                                    size="small"
                                    text="获取验证码"/>
                        </el-input>
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('removeForm')">取消</el-button>
                    <el-button size="small" @click="submitForm('removeForm')" type="primary">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import compSet from './compSet'
    import btnCountdown from 'components/btnCountdown'

    export default {
        components: {
            compSet,
            btnCountdown
        },
        data() {
            return {
                loading: false,
                searchVal: null,
                currentPage: 1,
                show: false,// 删除弹窗
                showAdd: false,// 新增弹窗
                selectChannel: {},
                form: {
                    name: '',// 名称
                    cmsAccount: '',// cms
                    contactAccount: '',// 联系
                },
                rules: {
                    name: [
                        {required: true, message: '请输入支付渠道名称', trigger: 'blur'}
                    ],
                    cmsAccount: [
                        {required: true, message: '请输入绑定CMS账号', trigger: 'blur'}
                    ]
                },
                removeForm: {// 删除渠道
                    id: '',
                    account: '',
                    password: '',
                    smsCode: ''
                },
                removeRules: {
                    account: [
                        {required: true, message: '请输入账号', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    smsCode: [
                        {required: true, message: '请输入验证码', trigger: 'blur'}
                    ]
                }
            }
        },
        computed: {
            ...mapState('payChannel', ['channelList', 'channelClubsQuery'])
        },
        created() {
            // 获取所有银行
            this.getBankList();
            this.getChannelPayment();
            this.getList();
            // 渠道类型
            this.getAllUnionList();
        },
        methods: {
            ...mapActions('other', ['sendCodeToMyPhone']),
            ...mapActions('union', ['getAllUnionList']),
            ...mapActions('payChannel', ['getBankList', 'getChannelPayment', 'getChannelList', 'createChannel', 'updateChannelRebate', 'deleteChannel']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getChannelList({
                    page,
                    search: this.searchVal
                }).then(() => {
                    this.loading = false;
                    if (!this.channelList.beanList.length && page !== 1) {
                        this.getList(this.currentPage - 1)
                    }
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (formName === 'addForm') {
                            // 新增支付渠道
                            this.createChannel(this.form).then(() => {
                                this.showAdd = false;
                                this.$message.success('新增成功');
                                this.getList(this.currentPage);
                                this.close(formName)
                            })
                        } else {
                            // 删除支付渠道
                            let params = Object.assign({}, this.removeForm, {
                                password: window.btoa(this.removeForm.password)
                            });
                            this.deleteChannel(params).then(() => {
                                this.show = false;
                                this.$message.success('删除成功');
                                this.getList(this.currentPage);
                                this.close(formName)
                            })
                        }
                    }
                })
            },
            close(formName) {
                this.$refs[formName].resetFields();
                if (formName === 'addForm') {
                    this.showAdd = false;
                } else {
                    this.show = false;
                }
            },
            // 需改是否战绩返佣
            updateRebate(id, openRebate) {
                this.$confirm(`您确认要${openRebate ? '开启' : '关闭'}战绩返佣吗`, '提示', {
                    type: 'info'
                }).then(() => {
                    this.updateChannelRebate({
                        id,
                        openRebate
                    }).then(() => {
                        this.$message.success('修改成功');
                        this.getList(this.currentPage);
                    })
                }).catch(() => {
                })
            },
            deleteFunc(row) {
                if (row.clubCount > 0) {
                    this.$message.error('该渠道配置了俱乐部，不可删除');
                    return
                }
                this.removeForm.id = row.id;
                this.show = true;
            },
            editFunc(row) {
                this.selectChannel = row;
                this.$refs.edit.show = true;
            },
            //渠道信息配置保存后更新当前选中的渠道的信息
            updateSelectChannel({channelName, contactAccount}) {
                this.selectChannel = Object.assign({}, this.selectChannel, {
                    name: channelName,
                    contactAccount
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .form {
        padding-top: 20px;

        :global(.el-form-item) {
            padding: 0 40px 0 30px;
        }
    }
</style>